<template>

    <form ref="ajudachamadomeucna-form-edit" v-on:submit.prevent="executeEdit(model)" v-if="model" novalidate>

        <div class="row">
            <div class="col-md-12">
                <h4 class="text-center"><strong>Assunto: </strong>{{ model.assunto }}</h4>
                <br />
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="alert alert-info" role="alert">
                    <p><strong>PessoaCNAId: </strong>{{ model.pessoaCNAId }}</p>
                    <p><strong>Responsável: </strong>{{ model.pessoaCNA.nome }}</p>
                    <p><strong>AlunoId: </strong>{{ model.alunoId }} - <strong>Aluno: </strong>{{ model.aluno.pessoaEscola.nome }}</p>
                    <p><strong>Idioma: </strong>{{ model.idioma.nome }}</p>
                    <p><strong>Situação: </strong>{{ model.statusAjudaChamadoMeuCNA.nome }} - {{ model.statusAjudaChamadoMeuCNA.descricao }}</p>
                    <p><strong>Data de abertura: </strong>{{ model.dataAbertura }} <strong>Data de interação: </strong>{{ model.dataSituacao }}</p>
                </div>
            </div>
        </div>

        <div class="row">

            <div class="form-group col-md-12">
                <label for="mensagemReplica">Digite uma resposta para o usuário</label>
                <textarea class="form-control" name="mensagemReplica" placeholder="Digite uma resposta para o usuário" v-model="model.mensagemReplica" v-htmleditor required></textarea>
            </div>

            <div class="form-group col-md-12">
                <label for="statusAjudaChamadoMeuCNAId">Defina a situação do chamado</label>
                <select v-select="{ dataitem: 'StatusAjudaChamadoMeuCNA', default: 'Selecione' }" v-model="model.statusAjudaChamadoMeuCNAId" class="form-control" name="statusAjudaChamadoMeuCNAId" required></select>
            </div>

        </div>

        <div class="row">
            <div class="col-md-12">
                <span>Histórico da conversa</span>
                <div class="alert alert-light" v-html="model.mensagem"></div>
            </div>
        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeEdit(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "ajudachamadomeucna-form-edit",
        mixins: [base],
        props: { id: Number },
        data: () => ({

            model: null,

            form: "ajudachamadomeucna-form-edit",

            resources: {
                edit: 'ajudachamadomeucna',
            },

        }),

        methods: {

            executeEdit: function (model) {

                if (this.formValidate() == false) return;

                new Api(this.resources.edit).put(model).then(data => {
                    this.defaultSuccessResult("Edição realizada com sucesso");
                    this.$emit('on-saved', data)
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },

        mounted() {
            new Api(this.resources.edit).get({ ajudaChamadoMeuCNAId: this.id }).then(data => {
                if (data.data) this.model = data.data;
                else if (!data.dataList) this.model = {};
                else if (data.dataList.length == 1) this.model = data.dataList[0];
                else this.model = {};
            }, err => {
                this.defaultErrorResult(err);
            })
        }
    };
</script>